import { z } from 'zod';
import {
  PanelTabValue,
  type PanelTabValueType,
  TabValue,
  type TabValueType,
} from '@/lib/types/itemPanel';

export const itemPanelSearchSchema = z.object({
  itemId: z
    .preprocess(
      (v: unknown) => (v === '' || v === undefined ? undefined : Number(v)),
      z.number().int().positive().optional(),
    )
    .optional(),
  panelTab: z.enum(Object.values(TabValue) as [TabValueType, ...TabValueType[]]).optional(),
  expanded: z
    .preprocess((v: unknown) => v === 'true' || v === true, z.boolean().optional())
    .optional(),
  openSheet: z
    .enum(Object.values(PanelTabValue) as [PanelTabValueType, ...PanelTabValueType[]])
    .optional(),
});
